<p-confirmDialog key="SUPref" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>
<p-confirmDialog key="ConfirmSU" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Options-->
<div class="TopDiv">
	<h4 style="text-align: Center; margin: -5px 0px 10px 0px">Search for a Preference:</h4>

	<div class="OptionsGrid">
		<label>School:</label>
		<caass-schoolselector [Disabled]="IsLoading() == true" [ShowAll]="SchoolSelectShowAll" [lstExtraOptions]="lstExtraOptions"> </caass-schoolselector>

		<label>Category:</label>
		<p-dropdown
			[disabled]="IsLoading() == true"
			[options]="lstCategory"
			[(ngModel)]="Category"
			optionLabel="Category"
			[filter]="true"
			filterBy="Category"
			[showClear]="false"
			placeholder="Select a Category"
		>
			<ng-template pTemplate="selectedItem">
				<div *ngIf="Category">
					<div class="form-control NoBorder" style="text-align: left">
						{{ Category.Category }}
					</div>
				</div>
			</ng-template>
			<ng-template let-CategoryItem pTemplate="item">
				<div>
					<div class="form-control NoBorder" style="text-align: left">
						{{ CategoryItem.Category }}
					</div>
				</div>
			</ng-template>
		</p-dropdown>

		<label>Filter:</label>
		<div class="FilterGrid">
			<input type="text" placeholder="Key Name or Key Value" class="form-control" [(ngModel)]="Filter" />
			<button [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onSearch()">Search</button>
		</div>
	</div>
</div>

<!--Table-->
<div>
	<p-table
		#mydt
		[value]="lstPreference"
		[loading]="loading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedPreference"
		dataKey="PreferenceID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<!--INSERT CUSTOM FILTERS HERE-->

				<!--Category-->
				<th>
					<p-columnFilter type="text" field="Category" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!-- <th>
					<p-columnFilter field="Category" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown #filterCategory [ngModel]="value" [options]="lstFilterCategory" (onChange)="filter($event.value)"
								placeholder="Any" [showClear]="true">
								<ng-template let-value pTemplate="item">
									<span>{{value}}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th> -->

				<!--KeyName-->
				<th>
					<p-columnFilter type="text" field="KeyName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--KeyValue-->
				<th>
					<p-columnFilter type="text" field="KeyValue" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--ScopeDesc-->
				<th>
					<p-columnFilter field="ScopeDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterScopeDesc
								[ngModel]="value"
								[options]="lstScopeDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--Notes-->
				<th>
					<p-columnFilter field="HasNotesDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterHasNotesDesc
								[ngModel]="value"
								[options]="lstHasNotesDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
					<!-- <p-columnFilter type="text" field="Notes" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="Category">Category<p-sortIcon field="Category"></p-sortIcon></th>
				<th pSortableColumn="KeyName">Key Name<p-sortIcon field="KeyName"></p-sortIcon></th>
				<th pSortableColumn="KeyValue">Key Value<p-sortIcon field="KeyValue"></p-sortIcon></th>
				<th pSortableColumn="ScopeDesc">Scope<p-sortIcon field="ScopeDesc"></p-sortIcon></th>
				<th pSortableColumn="Notes">Notes<p-sortIcon field="Notes"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-Preference>
			<tr [pSelectableRow]="Preference" (dblclick)="onRowDblClick(Preference)">
				<td *ngFor="let col of cols" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ Preference[col.field] }}
				</td>

				<td>
					<p *ngIf="Preference.Notes != ''" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
						{{ Preference.Notes }}
					</p>
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<div *ngIf="SelectedPreference != undefined" class="UpdateGrid">
	<h4 style="text-align: Center; grid-column: 1 / 3; margin: -5px 0px 0px 0px">Enter New Value:</h4>

	<label>Category:</label>
	<label class="InfoText">{{ SelectedPreference.Category }}</label>

	<label>Key Name:</label>
	<label class="InfoText">{{ SelectedPreference.KeyName }}</label>

	<label>Old Value:</label>
	<label class="InfoText">{{ SelectedPreference.KeyValue }}</label>

	<label>New Value:</label>
	<input type="text" class="form-control" [(ngModel)]="NewValue" />
</div>

<!--Buttons-->
<div class="Buttons">
	<button [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onUpdate()">Update</button>
	<button [disabled]="Processing == true" class="btn btn-warning" style="margin-left: 5px" (click)="onClose()">Close</button>
</div>

<!--Error Message-->
<div class="form-group TopMargin" style="margin-bottom: 40px">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
